var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"color",class:_vm.styleClass,on:{"click":function($event){return _vm.$emit('select')}}},[(_vm.selected)?_c('font-awesome-icon',{attrs:{"icon":"check"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }